import ModalAddSurveyData from "./ModalAddSurveyData";

export default ModalAddSurveyData;